/** Shown when something failed for a reason the user cannot act on. No retry - retrying will not help. */
export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please contact support.';

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/ai/useCases/runs/configs/aiRuns.config.ts
/** Shown when something failed and the failure was already reported to support. */
export const SUPPORT_NOTIFIED_MESSAGE = 'Something went wrong. Please try again. Our support team has been notified.';

/** Shown when the operation may well work on a second attempt. */
export const RETRY_OR_SUPPORT_MESSAGE = 'Please retry or contact support if the issue persists.';
